var map = {
	"./code.png": 4067,
	"./home.png": 773,
	"./ico.png": 485,
	"./logo.png": 3153,
	"./lunbo.png": 4482,
	"./pinpai.png": 129,
	"./pinpai1.png": 188,
	"./pinpai2.png": 8663,
	"./pinpai3.png": 974,
	"./pinpai4.png": 3441,
	"./youshi.png": 8025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;